import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  width?: number | string;
  height?: number | string;
}

const Star: React.FunctionComponent<Props> = (props) => {
  const { width = 15, height = 14, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={width}
      height={height}
      viewBox='0 0 15 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14.6275 5.21452H9.03913L7.31885 0L5.58838 5.21452L0 5.20453L4.51957 8.43113L2.7891 13.6456L7.30867 10.419L11.8282 13.6456L10.108 8.43113L14.6275 5.21452Z'
        fill='#00B67A'
      />
    </svg>
  );
};

export default Star;
